import request from '@dashboard/services/request';

const { REACT_APP_API_URL: apiUrl } = process.env;

const activateUser = (activationToken, token) =>
  request(`${apiUrl}/user/activate/${activationToken}`, token, {
    method: 'POST',
  });

export { activateUser };
